<template>

    <!-- BEGIN SECTION MODULE -->
    <div class="w-full bg-theme-level4 border-b border-theme-level2">

        <div id="sectionHeader" class="p-6 border-b border-theme-level2 flex flex-row items-center justify-between">
            <h2 class="text-theme-discrete font-bold text-xl" v-text="sectionTitle"></h2>
            <div id="section-controls">
                <i id="section-info-config" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted" style="font-size: 20px;">settings</i>
                <i id="section-info-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted" style="font-size: 20px;">info_outline</i>
                <i id="section-config-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted" style="font-size: 20px;">highlight_off</i>
            </div>
        </div>

        <!-- BEGIN SECTION CONTENT -->
        <!--<div id="mobile-section-content" class="section-container bg-theme-level3 p-4 md:p-6 text-theme-main">-->
        <div id="tablet-section-content" class="tablet-section-container bg-theme-level3 p-4 md:p-6 text-theme-main">

            <content-module-small
                v-for="contentPiece in contentPayload" v-if="contentPiece.render_size === 'Pequeño'"
                v-bind:key="contentPiece.id"
                :content="contentPiece"
                style="order: 2;"
            ></content-module-small>

            <content-module-large
                v-for="contentPiece in contentPayload" v-if="contentPiece.render_size === 'Grande'"
                v-bind:key="contentPiece.id"
                :content="contentPiece"
                style="order: 1;"
            ></content-module-large>

            <!--<content-module-small
                :content="content"
            ></content-module-small>

            <content-module-large
                :content="content"
            ></content-module-large>-->

            <!--<div class="col-span-2 row-span-2 relative item shadow">

            </div>-->

            <!--<content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>
            <content-module-small
                :content="content"
            ></content-module-small>-->

            <!-- END SECTION CONTENT -->
        </div>

    <!-- END SECTION MODULE -->
    </div>

</template>

<script>

    export default {

        data() {
            return {
                componentLoading: true,
                publish_date: '22/03/2020 24:58',
                contentPayload: '',
            }
        },

        props: [
            'filter',
            'sectionTitle'
        ],

        mounted() {
            /*console.log('A ContentSection module was mounted.');*/
            // Event.fire('closeSidebar');
        },

        created() {

            this.componentLoading = true;

            /*console.log('Getting data for a SECTION component...');*/

            axios.get('/api/filter/category/' + this.filter)
                .then(response => {
                    /*console.log('Server Responded well... moving on.');*/
                    this.contentPayload = response.data;
                    this.componentLoading = false;
                    /*console.log('DONE with data for section');*/
                })
                .catch(error => {
                    this.componentLoading = false;
                    console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                });
        },

    }

</script>


<style>

    :root {
        --gutter: 20px;
    }

    .tablet-section-container {
        padding: var(--gutter);
        display: grid;
        grid-gap: calc(var(--gutter) / 2);
        grid-template-columns: repeat(3, minmax(240px, 1fr));
        grid-template-rows: repeat(2, minmax(280px, 1fr));
        align-content: start;
    }

    .tablet-section-container {
        overflow-y: scroll;
    }

</style>
